import { ISection } from '@sdk/contracts';
import { Button, Flex, Modal } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

import { SectionNameWrapper } from './RemoveSection.styles';

import { Icon } from '@/components/Icon';
import { useMutateSection } from '@/store';

type Props = {
  courseId: string;
  section: ISection;
};

const MODAL_WIDTH = 400;

export const RemoveSection: React.FC<Props> = ({ courseId, section }) => {
  const { isWorking, removeSection } = useMutateSection();
  const { t } = useTranslation(['CourseTranslations', 'DefaultTranslations']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteSection = () => removeSection({ courseId, sectionId: section._id });

  return (
    <>
      <Button
        danger
        type="text"
        loading={isWorking}
        onClick={e => {
          e.stopPropagation();
          setIsModalOpen(true);
        }}
        icon={<Icon i="TrashCan" />}>
        {t('CourseTranslations:DELETE_SECTION')}
      </Button>

      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        okText={t('CourseTranslations:DELETE_SECTION')}
        cancelText={t('DefaultTranslations:CANCEL')}
        onOk={handleDeleteSection}
        centered
        width={MODAL_WIDTH}
        title={t('CourseTranslations:DELETE_SECTION_QUESTION')}
        wrapProps={{ onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() }}>
        <Flex vertical style={{ paddingTop: 16, paddingBottom: 16 }}>
          <span>
            <Trans
              i18nKey="CourseTranslations:DELETE_SECTION_DESCRIPTION"
              values={{ name: section.name }}
              components={{ bold: <SectionNameWrapper /> }}
            />
          </span>
          <span>{t('CourseTranslations:THIS_ACTION_CANNOT_BE_UNDONE')}</span>
        </Flex>
      </Modal>
    </>
  );
};
